module.exports = __webpack_public_path__ + "static/media/icon-how-it-works2.a8f48e34.svg";